import { render } from "./form.vue?vue&type=template&id=1a62f752"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=1a62f752&lang=css"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a62f752"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a62f752', __exports__)) {
    api.reload('1a62f752', __exports__)
  }
  
  module.hot.accept("./form.vue?vue&type=template&id=1a62f752", () => {
    api.rerender('1a62f752', render)
  })

}


export default __exports__